import React, { useState } from 'react';
import { ToggleButtonItem, ToggleButton, Panel, PanelTheme } from '@apply/components';

export const ToggleButtonDemo: React.FC<{}> = ({}) => {
    const [moneySelected, set_moneySelected] = useState<string[]>(['dollar']);
    const [yesNoSelected, set_yesNoSelected] = useState<string[]>(['Yes']);

    const yesNoButtonItems: ToggleButtonItem[] = [
        {
            id: 'Yes',
            text: 'Yes',
            hint: 'Click Yes',
        },
        {
            id: 'No',
            text: 'No',
            hint: 'Click No',
        },
    ];

    const dollarPercentButtonItems: ToggleButtonItem[] = [
        {
            id: 'dollar',
            text: '$',
            hint: 'Click $',
        },
        {
            id: 'percent',
            text: '%',
            hint: 'Click %',
        },
    ];

    const onMoneyItemsChange = (item: string) => {
        set_moneySelected([item]);
    };

    const onYesItemsChange = (item: string) => {
        set_yesNoSelected([item]);
    };

    return (
        <div style={{ marginTop: '20px', marginBottom: '20px' }}>
            <li style={{ color: 'grey' }}>Toggle Button</li>
            <br />
            <Panel
                theme={PanelTheme.White}
                width='200px'
            >
                <ToggleButton
                    id='toggleButtonDemoYesNo'
                    items={yesNoButtonItems}
                    selectedItems={yesNoSelected}
                    stylingMode='outlined'
                    selectionMode='single'
                    onItemClick={(e) => onYesItemsChange(e?.itemData.id)}
                    width='180px'
                />
                <br />
                <ToggleButton
                    id='toggleButtonDemoPercentDollar'
                    items={dollarPercentButtonItems}
                    selectedItems={moneySelected}
                    stylingMode='outlined'
                    selectionMode='single'
                    onItemClick={(e) => onMoneyItemsChange(e?.itemData.id)}
                    width='80px'
                />
            </Panel>
        </div>
    );
};
